// Admin Wire dropdown — vanilla JS, Turbo-compatible (same pattern as user_menu.js)

function closeWireDropdown() {
  const panel = document.getElementById("admin-wire-panel");
  const trigger = document.getElementById("admin-wire-trigger");
  if (panel) panel.classList.remove("open");
  if (trigger) trigger.setAttribute("aria-expanded", "false");
}

function openWireDropdown() {
  const panel = document.getElementById("admin-wire-panel");
  const trigger = document.getElementById("admin-wire-trigger");
  if (panel) panel.classList.add("open");
  if (trigger) trigger.setAttribute("aria-expanded", "true");
}

document.addEventListener("click", function (e) {
  const panel = document.getElementById("admin-wire-panel");
  const trigger = document.getElementById("admin-wire-trigger");
  if (!panel || !panel.classList.contains("open")) return;
  if (!panel.contains(e.target) && !trigger.contains(e.target)) {
    closeWireDropdown();
  }
});

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") closeWireDropdown();
});

document.addEventListener("turbo:before-cache", closeWireDropdown);

function initWireDropdown() {
  const trigger = document.getElementById("admin-wire-trigger");
  if (!trigger) return;

  if (trigger.dataset.menuInitialized) return;
  trigger.dataset.menuInitialized = "true";

  trigger.addEventListener("click", function (e) {
    e.stopPropagation();
    const panel = document.getElementById("admin-wire-panel");
    if (panel && panel.classList.contains("open")) {
      closeWireDropdown();
    } else {
      openWireDropdown();
    }
  });
}

document.addEventListener("turbo:load", initWireDropdown);
